import { render } from "./ProfileRequesterContent.vue?vue&type=template&id=5e965e05&scoped=true"
import script from "./ProfileRequesterContent.vue?vue&type=script&lang=js"
export * from "./ProfileRequesterContent.vue?vue&type=script&lang=js"

import "./ProfileRequesterContent.vue?vue&type=style&index=0&id=5e965e05&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e965e05"]])

export default __exports__